import React from 'react';
import type { Error } from '../../../types/models/error';
import styled from 'styled-components';
import { DateAttr } from '../../../components/date-attr';

const ListItem = styled.li`
  display: grid;
  grid-template-columns: 5em 2fr 1fr 1fr;
  grid-gap: 1em;
`;
interface ErrorItemProps {
  error: Error;
}

export function ErrorItem(props: ErrorItemProps) {
  return (
    <>
      <ListItem>
        <DateAttr date={props.error.dateTime} />
        <span>{props.error.errorDetail}</span>
        <span>{props.error.serviceProviderId}</span>
        <span>{props.error.deviceUUID}</span>
      </ListItem>
    </>
  );
}
